import { Observable } from 'rxjs';
import { BaseApi } from '../base-api';
import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { PaginationMeta } from '@app/shared/components/data-table/data-table.component';

export interface ApiResponse {
    status: string;
    message?: string;
}

export interface FAQData {
    id?: number;
    question: string;
    answer: string;
    category_id: string;
}

export interface FAQCategoryData {
    id: number;
    name: string;
    description: string;
}

export interface FAQCategoryResponse extends ApiResponse {
    data: FAQCategoryData[];
}

export interface FAQResponse extends ApiResponse {
    data: FAQData[];
}

export interface FAQListResponse extends PaginationMeta {
    data: FAQData[];
}

export interface FAQCategoryListResponse extends PaginationMeta {
    data: FAQCategoryData[];
}

@Injectable({
    providedIn: 'root',
})
export class FaqService extends BaseApi {
    getFAQs(options?: HttpParams): Observable<FAQListResponse> {
        return this.get<FAQListResponse>('faqs', {
            params: options,
        });
    }

    getAllFAQs(options?: HttpParams): Observable<FAQResponse> {
        return this.get<FAQResponse>('faqs/all', {
            params: options,
        });
    }

    createFAQ(data: any): Observable<FAQResponse> {
        return this.post<FAQResponse>('faqs', data);
    }

    updateFAQ(id: number, data: any): Observable<FAQResponse> {
        return this.put<FAQResponse>(`faqs/${id}`, data);
    }

    deleteFAQ(id: number): Observable<ApiResponse> {
        return this.delete<ApiResponse>(`faqs/${id}`);
    }

    getFAQCategories(
        options?: HttpParams
    ): Observable<FAQCategoryListResponse> {
        return this.get<FAQCategoryListResponse>('faqs-categories', {
            params: options,
        });
    }

    getAllFAQCategories(): Observable<FAQResponse> {
        return this.get<FAQResponse>('faqs-categories/all');
    }

    createFAQCategory(data: any): Observable<FAQCategoryResponse> {
        return this.post<FAQCategoryResponse>('faqs-categories', data);
    }

    updateFAQCategory(id: number, data: any): Observable<FAQCategoryResponse> {
        return this.put<FAQCategoryResponse>(`faqs-categories/${id}`, data);
    }

    deleteFAQCategory(id: number): Observable<FAQCategoryResponse> {
        return this.delete<FAQCategoryResponse>(`faqs-categories/${id}`);
    }
}
